import { atom } from 'recoil';

type ShareModal = {
  id: string;
};

export const dataModalState = atom<ShareModal>({
  key: 'DATA_MODAL_STATE',
  default: { id: '' },
});
